import React, { Component } from 'react';
import { connect } from 'react-redux';
import Prematch from '..';
import SearchBar from './SearchBar';
import * as Maps from '../../../store/map';

class Search extends Component {
    componentDidMount() {
        this.props.lsportsActions.prematch.clearSearch();
    }

    render() {
        return (
            <div className="main-container">
                <SearchBar />
                <Prematch />
            </div>
        );
    }
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(Search);
